import {updateClanPendingCount} from "./alpine-helpers.js";
import {showToast} from "../utils";

/**
 * Shows error toast notification
 */
function showErrorToast() {
    showToast("Une erreur est survenue.", "danger");
}

/**
 * Sets up all event listeners for the application
 */
export function setupEventHandlers() {
    document.addEventListener("clan:pendingCount", (event) => {
        updateClanPendingCount(event.detail.count);
    });

    document.body.addEventListener("htmx:responseError", showErrorToast);

    // Reload page on browser back/forward navigation
    window.addEventListener("popstate", () => {
        window.location.reload();
    });

    // Mark challenge as completed (green border)
    document.addEventListener("challenge:completed", (event) => {
        const { challengeSlug } = event.detail;

        const challengeCard = document.querySelector(
            `.challenge-card[data-challenge-slug="${challengeSlug}"]`
        );

        if (challengeCard) {
            // Remove red border and add green border with animation
            challengeCard.classList.remove('border-red-500');
            challengeCard.classList.add('border-green-500');

            // Update data attribute
            challengeCard.dataset.validated = '1';
        }
    });
}
